<template>
  <default-modal
    ref="box"
    :title="title"
    :modalWidth="600"
    :confirmTxt="confirmText"
    @confirm="confirm"
  >
    <div class="modal-body">
      <div>
        <div class="row">
          你确定要删除该规则吗？
        </div>
        <div class="row">{{ ruleId }}-{{ ruleName }}</div>
      </div>
    </div>
  </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";

import { delRule } from "@/requests/securityCenter";
export default {
  components: {
    DefaultModal,
  },
  data() {
    return {
      ruleId: "",
      ruleName: "",
      title: "删除规则",
      confirmText: "",
      successFn: "",
    };
  },
  mounted() {
    window.$modal.delRulesModal = {};
    window.$modal.delRulesModal.show = (id, ruleName) => {
      this.ruleId = id;
      this.ruleName = ruleName;
      this.confirmText = "确定";
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true);
        });
      });
    };
  },
  methods: {
    // 初始化信息
    init(fn) {
      this.$refs.box.show();
      this.successFn = fn;
    },
    async confirm() {
      let resValue = await delRule({
        id: this.ruleId,
      });
      if (resValue.code == 200) {
        this.$refs.box.hide();
        this.successFn();
      } else {
        this.$refs.box.setWrong(resValue.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 10px 0 10px 50px;
  text-align: left;
  .row {
    height: 30px;
    line-height: 30px;
  }
}
</style>
